import {validateInput, validateIsraeliID, TextInputEnum} from './InputValidation';
import {errorMessages} from './validationVariables';
import {isNullOrEmpty} from '../StringHelpers/StringHelpers';

export enum IdNumberType {
  Passport = 'P',
  Company = 'C',
  IsraeliId = 'I',
}

export const ID_NUMBER_TYPE_OPTIONS = [
  {value: IdNumberType.Passport, label: 'דרכון'},
  {value: IdNumberType.Company, label: 'ח.פ'},
  {value: IdNumberType.IsraeliId, label: 'תעודת זהות'},
];

export interface ActivateNiudFormValues {
  idNumberType: string;
  idNumber: string;
  hostNumber: string;
  niudNumber: string;
}

export interface ActivateNiudFormErrors {
  idNumberType?: string;
  idNumber?: string;
  hostNumber?: string;
  niudNumber?: string;
}

export function validateIdNumberByType(type: string, value: string): string {
  if (isNullOrEmpty(value)) {
    return errorMessages.emptyValue;
  }

  switch (type) {
    case IdNumberType.IsraeliId: {
      if (!/^\d{9}$/.test(value)) {
        return 'יש להזין 9 ספרות';
      }
      if (!validateIsraeliID(value)) {
        return 'ת.ז לא תקינה';
      }
      return '';
    }
    case IdNumberType.Company: {
      if (!/^\d{9}$/.test(value)) {
        return 'יש להזין 9 ספרות';
      }
      if (!validateIsraeliID(value)) {
        return 'ח.פ לא תקין';
      }
      return '';
    }
    case IdNumberType.Passport: {
      if (!/^[A-Za-z0-9]{6,9}$/.test(value)) {
        return 'מספר דרכון לא תקין';
      }
      return '';
    }
    default:
      return 'יש לבחור סוג מזהה';
  }
}

export function validateActivateNiudForm(form: ActivateNiudFormValues): {
  isValid: boolean;
  errors: ActivateNiudFormErrors;
} {
  const errors: ActivateNiudFormErrors = {};

  if (isNullOrEmpty(form.idNumberType)) {
    errors.idNumberType = errorMessages.emptyValue;
  }

  const idNumberError = validateIdNumberByType(form.idNumberType, form.idNumber);
  if (idNumberError) {
    errors.idNumber = idNumberError;
  }

  const hostNumberError = validateInput(form.hostNumber, TextInputEnum.Phone);
  if (hostNumberError) {
    errors.hostNumber = hostNumberError;
  }

  const niudNumberError = validateInput(form.niudNumber, TextInputEnum.Phone);
  if (niudNumberError) {
    errors.niudNumber = niudNumberError;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
